import { render, staticRenderFns } from "./UploadExpenseFiles.vue?vue&type=template&id=05ca5446"
import script from "./UploadExpenseFiles.vue?vue&type=script&lang=js"
export * from "./UploadExpenseFiles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports